import { configureStore } from "@reduxjs/toolkit";
import ActivePageSlice from "./activePage";
import UserStatusSlice from "./userStatus";
const store = configureStore({
  reducer: {
    activePage: ActivePageSlice,
    userStatus: UserStatusSlice,
  },
});

export default store;
